(function () {
  if (window.__nfStockUrgency) return;
  window.__nfStockUrgency = true;

  function refreshUrgency(variantId) {
    var els = document.querySelectorAll('[data-nf-stock-urgency]');
    if (!els.length) return;

    var dataScript = document.querySelector('.js-inventory-data');
    if (!dataScript) return;

    var variants;
    try { variants = JSON.parse(dataScript.textContent); }
    catch (e) { return; }

    var v = variants.find(function (x) { return String(x.id) === String(variantId); });

    els.forEach(function (el) {
      if (!v) { el.classList.add('hidden'); return; }

      var threshold = parseInt(el.dataset.threshold, 10) || 10;
      var inv = parseInt(v.inventory_quantity, 10) || 0;
      var hasInventoryMgmt = v.inventory_management && v.inventory_management !== '';

      if (hasInventoryMgmt && v.available && inv > 0 && inv <= threshold) {
        var countEl = el.querySelector('[data-nf-stock-count]');
        if (countEl) countEl.textContent = inv;
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });
  }

  document.addEventListener('on:variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.id) refreshUrgency(v.id);
  });
})();
